export default __webpack_public_path__ + "arrow_right_56.svg";